export default "__VITE_ASSET__BdMy48Ha__"